module.exports = "/shifts/components/moreOptionsMenuComponent-a9a5a1.html";